/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserStatusSummaryResponse {
    getFixupPrototypeFunction() { return UserStatusSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<UserStatusSummaryResponse>): UserStatusSummaryResponse {
        let obj = Object.assign(new UserStatusSummaryResponse(), model);
        UserStatusSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserStatusSummaryResponse>): UserStatusSummaryResponse {
        if (!model) return null;
        return UserStatusSummaryResponse.newInstance(<UserStatusSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserStatusSummaryResponse) {
        if (!obj) return;

        models.UserStatusSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserStatusSummaryResponse): boolean {
        Object.setPrototypeOf(obj, UserStatusSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total === undefined) {
            this.total = 0;
        }
        if (this.active === undefined) {
            this.active = 0;
        }
        if (this.suspended === undefined) {
            this.suspended = 0;
        }
        if (this.pending_activation === undefined) {
            this.pending_activation = 0;
        }
        if (this.inactive === undefined) {
            this.inactive = 0;
        }
    }

    /**
     * Total number of users visible to the caller
     */
    total: number;

    /**
     * Number of users with status active
     */
    active: number;

    /**
     * Number of users with status suspended
     */
    suspended: number;

    /**
     * Number of users with status pending_activation
     */
    pending_activation: number;

    /**
     * Number of users in any other status (verified, rejected)
     */
    inactive: number;

}
